import { render, staticRenderFns } from "./EntrepreneurParallax.vue?vue&type=template&id=0117c02b&scoped=true&"
import script from "./EntrepreneurParallax.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurParallax.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurParallax.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EntrepreneurParallax.vue?vue&type=style&index=1&id=0117c02b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0117c02b",
  null
  
)

export default component.exports